<div class="" *ngIf="isUserLogin">
    <loading-contents *ngIf="websites == null || photos == null"></loading-contents>
    <div class="dashborad padding-top-30" *ngIf="websites != null && photos != null">
        <div class="container">
            <dashboard-header></dashboard-header>
            <div class="row">
                <div class="padding-bottom-30 col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <h5>Web Development</h5>
                    <div class="row">
                        <div class="item col-lg-6 col-xs-6 col-md-6 col-sm-6" (click)="onSelect(website)"  *ngFor="let website of websites">
                            <div class="card">
                                <div class="card-image">
                                <img src="../../assets/images/websites/thumbnail/{{website.thumbnail_image}}" class="card-img-top" alt="{{website.title}}">
                                </div>                            
                                <div class="card-body">
                                <div class="body-wrapper">                                
                                    <div class="siteTitle">
                                    <h6>{{website.title}}</h6>
                                    <span>Build by: {{website.item_category}}</span>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-outline-light btn-sm" (click)="goWeb()">View All</button>
                </div>
                <div class="padding-bottom-30 col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <h5>Photography</h5>
                    <div class="row">
                        <div class="item col-lg-6 col-xs-6 col-md-6 col-sm-6" (click)="onSelectPotography(item)"  *ngFor="let item of photos">
                            <div class="card">
                                <div class="card-image">
                                <img src="../../assets/images/photography/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                                </div>                            
                                <div class="card-body">
                                <div class="body-wrapper">                                
                                    <div class="siteTitle">
                                    <h6>{{item.title}}</h6>
                                    <span>{{item.item_category}}</span>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-outline-light btn-sm" (click)="goPhotogrphy()">View All</button>
                </div>
                <div class="padding-bottom-30 col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <h5>Message</h5>
                    <div class="row">
                        <div class="item col-lg-6 col-xs-6 col-md-6 col-sm-6" *ngFor="let item of messages">
                            <div class="card">
                                <div class="card-contents">
                                    <p><span class="bold">Name: </span>{{item.name}}</p>
                                    <p><span class="bold">Sent form: </span>{{item.ip}}</p>
                                    <p><span class="bold">Sent time: </span>{{item.createTime}}</p>
                                    <p><span class="bold">Message: </span>{{item.message}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-outline-light btn-sm" (click)="goMessage()">View All</button>
                </div>
                <div class="padding-bottom-30 col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <h5>User</h5>
                    <div class="row">
                        <div class="item col-lg-6 col-xs-6 col-md-6 col-sm-6" *ngFor="let item of users">
                            <div class="card">
                                <div class="card-contents">
                                    <p><span class="bold">Name: </span>{{item.name}}</p>
                                    <p><span class="bold">email: </span>{{item.email}}</p>
                                    <p *ngIf="item.active == 1"><span class="bold">Status: </span>Active</p>
                                    <p *ngIf="item.active == 0"><span class="bold">Status: </span>Inactive</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-outline-light btn-sm" (click)="goWeb()">View All</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="" *ngIf="!isUserLogin">
    <app-slider></app-slider>
    <div class="loading">
        <div class="wrapper padding-top-30">
            <div class="container">
                <p>Oops, The page you are looking for can't be found!</p>
                <div class="missing-page">
                    <span class="side">4</span>
                    <span class="taiji-icon"></span>
                    <span class="side">4</span>
                </div>
                <p>Loading...</p>
            </div>
        </div>
    </div>
    <div class="socail-media padding-top-30">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <instagram-post></instagram-post>
                </div>
                <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <tumblr-posts></tumblr-posts>
                </div>
            </div>
        </div>
    </div>
</div>
<router-outlet></router-outlet>